/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-27T03:12:48.094Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 24
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 25
	'FollowingFeedWithSortByStorageSnippetsQuery', // 26
	'FooterCreateButtonsQuery', // 27
	'ForgeExtensionList', // 28
	'GlobalNavigationComponentQuery', // 29
	'GrantAccessDialogLoaderQuery', // 30
	'HomeRecentWorkQuery', // 31
	'InlineCommentsFocusedInlineCommentQuery', // 32
	'LegacyMacroRendererQueryBodyQuery', // 33
	'LivePagesByLineLastUpdatedQuery', // 34
	'LocalStorageQuery', // 35
	'NativeCollabQuery', // 36
	'NotFoundContainerQuery', // 37
	'NotificationsButtonQuery', // 38
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 39
	'PageRestrictionsContextQuery', // 40
	'PageTreeQuery', // 41
	'PageTreeQueryWithSpaceKeyQuery', // 42
	'PermissionCheckAddCommentQuery', // 43
	'PersistentInviteEligibleQuery', // 44
	'PersonalizedTemplatesV2AllTemplatesQuery', // 45
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsV2Query', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RendererContentStateQuery', // 51
	'RestrictedPageWithCanViewQuery', // 52
	'ScreenQuery', // 53
	'SiteInformationQuery', // 54
	'SmartCreateFeedbackBannerQuery', // 55
	'SmartCreatePageEditorDataWrapperComponentQuery', // 56
	'SpaceNavigationQuery', // 57
	'SpaceOverviewIdQuery', // 58
	'SpaceOverviewQuery', // 59
	'SpaceQuery', // 60
	'SpaceRestrictionCheckQuery', // 61
	'ThemeQuery', // 62
	'TopNavigationQuery', // 63
	'UserSettingsQuery', // 64
	'ViewSpaceExternalCollaboratorsDialogQuery', // 65
	'WebItemLocationQuery_page.metadata.banner', // 66
	'WebItemLocationQuery_system.content.byline', // 67
	'WebItemLocationQuery_system.header_left', // 68
	'WebItemLocationQuery_system.header_left_system.user', // 69
	'WebPanelLocationQuery_atl.footer', // 70
	'WebPanelLocationQuery_atl.general', // 71
	'WebPanelLocationQuery_atl.general_atl.footer', // 72
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 73
	'WebStorageCategories', // 74
	'WelcomeMessagesQuery', // 75
	'WhiteboardUnifiedQuery', // 76
	'bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 77
	'bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences', // 78
	'contentAppearanceQuery', // 79
	'contentSmartLinksORS', // 80
	'fetchMentionsProviderDataQuery', // 81
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 82
	'graphqlHelpersFetchMediaTokenQuery', // 83
	'multiMacroQueryWithAppKeyQuery', // 84
	'onboardingStateGetOnboardingStateQuery', // 85
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 86
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 87
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 90
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2', // 91
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 92
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 93
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 100
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 102
	'pageButtons', // 103
	'preloadAutohighlightsQuery', // 104
	'preloadContentSmartLinksQuery', // 105
	'preloadCreateSpaceQuery', // 106
	'preloadEditButtonWithSpaceKeyQuery', // 107
	'preloadEditorNodeDataProvidersDataQuery', // 108
	'preloadForgeApps_FetchPreFilteredForgeAppsQuery', // 109
	'preloadLegacyBridgeQuery', // 110
	'preloadOperationsQuery', // 111
	'preloadPageStatusQueryDataQuery', // 112
	'preloadPersonalSpaceDetailsQuery', // 113
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 114
	'preloadSpaceBlogCountQuery', // 115
	'preloadTemplatesCollectionEligibleQuery', // 116
	'requireSuperBatchFrontendResourceRenderQuery', // 117
	'rightPanel', // 118
	'searchResults', // 119
	'shortcutsSmartLinksQuery', // 120
	'sidenavSmartLinksORS', // 121
	'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 122
	'useAnalyticsByLineQuery', // 123
	'useAudioContentQuery', // 124
	'useConfluenceStandardToPremiumExperimentQuery', // 125
	'useContentClassificationContentDataClassificationQuery', // 126
	'useEditorContentModeValueQuery', // 127
	'useEmojiEverSetPropertyQuery', // 128
	'useFabricEligibilityMigrationQuery', // 129
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 130
	'useFeedTypeSelectorRefreshQuery', // 131
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 132
	'useGetCurrentStorageUsageQuery', // 133
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 134
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 135
	'useHomeWidgetStateQuery', // 136
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 137
	'useIsLoomEntryPointsEnabledQuery', // 138
	'useIsUserViewingSpaceAsAnonQuery', // 139
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 140
	'useLoomTenantProvisionStatusQuery', // 141
	'usePopularFeedWithTimeGranularityStorageQuery', // 142
	'usePreloadCommentButtonQuery', // 143
	'useReadTimeQuery', // 144
	'useRegisterAdminAnnouncementBannerQuery', // 145
	'useShareAndRestrictButtonDataQuery', // 146
	'useShortcutsSpaceNavigationQuery', // 147
	'useSpaceBaseQueryBaseQuery', // 148
	'useSpaceDetailQuery', // 149
	'useSpaceEnabledContentTypesQuery', // 150
	'useSpaceViewsDataSpaceRootQuery', // 151
	'useSpaceViewsOptionsPersistenceQuery', // 152
	'useSpacesDataAnonymousSpacesQuery', // 153
	'useSpacesDataMyVisitedSpacesQuery', // 154
	'useSpacesDataStarredSpacesQuery', // 155
	'useTitleContentPropertiesForEditorQuery', // 156
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 157
	'useTitleContentPropertiesForPublishedPageQuery', // 158
	'useUserByLicensedProductsQuery', // 159
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b39fd2ffbffdfb6fefdffff7ff4cfbdfff9', /* 130 fast, 17 slow, 9 excl */
	'prod-apne2': '35ff7b39fd2ffbfedfb6fefdffff5ffcefbdfff9', /* 129 fast, 15 slow, 48 excl */
	'prod-apse': 'bdff7bfbfd2fffffdfbefefdfffffffcefbdfffb', /* 140 fast, 13 slow, 9 excl */
	'prod-apse2': 'bdff7b7bfd2fffffdfbefefdfffffffcefbdffff', /* 140 fast, 12 slow, 13 excl */
	'prod-apsouth': '15ff7b39fd2ffbffdfbefefdffffdffcefbdfffd', /* 132 fast, 13 slow, 81 excl */
	'prod-cacentral': 'bdff7bb9fd3fffffdfbefefdffffdffcefbffffd', /* 139 fast, 8 slow, 11 excl */
	'prod-east': '9dff7ffbfd3fffffdfbefefdfffffffdefbfffff', /* 144 fast, 11 slow, 58 excl */
	'prod-eucentral': '9fff7ffbfd2fffffdfb6fefdfffffff5efbdfffb', /* 140 fast, 15 slow, 58 excl */
	'prod-eucentral2': '25df7b19fd2ffffe9f96eebdffff07f4efbdff79', /* 118 fast, 26 slow, 12 excl */
	'prod-euwest': 'bfff7ffbfd3fffffdfbefefdfffffff5efbfffff', /* 145 fast, 11 slow, 57 excl */
	'prod-euwest2': 'bdff7bfbfd3fffffdfbefefdffffdffcefbffff9', /* 140 fast, 9 slow, 13 excl */
	'prod-west2': '9dff7b7bff3fffffdfbefefdfffffffcefbffffb', /* 141 fast, 11 slow, 50 excl */
	'stg-east': '76b3fbbdd4bbdde6ffabff771ff7dbf9dfffefdd', /* 123 fast, 13 slow, 61 excl */
};
